import { connect } from 'react-redux';

import { RootReducerStateT } from 'app/reducers/rootReducer';
import { AppDispatch } from 'bootstrap.store';
import { bindActionToPromise } from 'utils/sagaApiGeneratorHelpers';

import { callFlowsActions } from '../../../../powerCallFlow/actions/callFlowsActions';
import * as telephonyActions from '../../../actions/telephony';
import EditNumberModal from '../../../components/sections/telephony/modals/editNumberModal';

export const {
  telephonyShowEditNumberModal,
  telephonyHideEditNumberModal,
  telephonyUpdateNumber,
  updateNumber,
  setLabel,
  getAllNumbers,
} = telephonyActions.actions;

const { telephonyGetQueryNumbersPage, callFlowsFetchAll } = callFlowsActions;

export type SelectedNumberT = {
  name: string;
  record_outbound_calls: boolean;
};

export type StateProps = ReturnType<typeof mapStateToProps>;
export type DispatchProps = ReturnType<typeof mapDispatchToProps>;

const getInitialValues = (selectedNumber: SelectedNumberT | undefined) => {
  const { name, record_outbound_calls } = selectedNumber || {};

  return {
    name: name ?? '',
    record_outbound_calls: record_outbound_calls ?? false,
  };
};

const mapStateToProps = (state: RootReducerStateT, ownProps: any) => {
  const { selectedNumber } = state.settings.telephony;
  const initialValues = getInitialValues(
    selectedNumber ?? ownProps.selectedNumber,
  );

  return {
    meta: state.settings.telephony.meta,
    numbers: state.settings.telephony.numbers,
    organizationId: state.settings.organization.organization.id,
    selectedNumber: state.settings.telephony.selectedNumber,
    newNumberLabel: state.settings.telephony.newNumberLabel,
    featureflags: state.settings.organization.featureflags,
    initialValues,
  };
};

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  showEditNumberModal: (number: any) =>
    dispatch(telephonyShowEditNumberModal(number)),
  hideEditNumberModal: bindActionToPromise(
    dispatch,
    telephonyHideEditNumberModal,
  ),
  updateNumber: bindActionToPromise(dispatch, telephonyUpdateNumber),
  onChangePhoneLabel: bindActionToPromise(dispatch, setLabel),

  // @TODO: clean this up when merging CallflowsList
  callFlowsFetchAll: bindActionToPromise(dispatch, callFlowsFetchAll),
  telephonyGetQueryNumbersPage: bindActionToPromise(
    dispatch,
    telephonyGetQueryNumbersPage,
  ),
});

const mapOwnProps = (state: StateProps, dispatch: DispatchProps, own: any) => ({
  ...state,
  ...dispatch,
  /*
   * Overwrite with passed props due to having to accommodate
   * the new settings page which does not rely on redux state.
   */
  ...own,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mapOwnProps,
)(EditNumberModal);
